$('#vote .rating').rating({
    initialRating: 2,
    maxRating: 5
});
